import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./Redux/Store";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import 'react-overlay-loader/styles.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
reportWebVitals()
